import { string } from 'prop-types'
import * as React from 'react'

function Letter({ stroke = '#1F2D27', ...props }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3503_4903)">
        <g clipPath="url(#clip1_3503_4903)">
          <path
            d="M6.18133 6.72656L25.8173 6.72656C27.0227 6.72656 28 7.7039 28 8.90923L28 23.0906C28 24.2959 27.0227 25.2719 25.8187 25.2719L6.18133 25.2719C5.89483 25.2721 5.6111 25.2158 5.34637 25.1062C5.08164 24.9966 4.8411 24.836 4.63851 24.6334C4.43592 24.4308 4.27525 24.1903 4.16569 23.9255C4.05613 23.6608 3.99983 23.3771 4 23.0906L4 8.90923C4 7.7039 4.97733 6.72656 6.18133 6.72656Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.1582 8.1007L14.4169 15.438C14.8689 15.7615 15.4106 15.9356 15.9664 15.9361C16.5223 15.9366 17.0643 15.7634 17.5169 15.4407L27.8342 8.08203"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3503_4903">
          <rect width="32" height="32" fill="white" />
        </clipPath>
        <clipPath id="clip1_3503_4903">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

Letter.propTypes = {
  stroke: string,
}

export { Letter }
